
export default {
  data () {
    return {
      info: 'MDF should be stored in a dry, well ventilated area undercover. The panels should be stored flat with uniform and vertically aligned support bearers which should be placed evenly at 600mm centres. For thinner panels, we recommend the use of thick (>17mm) base boards. All packing materials should be disposed of thoughtfully.',
      infoWork: 'MDF can be cut, machined, sanded and drilled with commonly available woodworking equipment. The surface can also be painted or finished with wood veneers or paper.',
      data: [
        {
          id: 1,
          icon: 'icon-work-01',
          title: 'Cutting',
          info: 'The best cutting can be obtained using 72-96 teeth saw blades.'
        },
        {
          id: 2,
          icon: 'icon-work-02',
          title: 'Joining',
          info: 'It is recommended that correctly sized pilot holes should be drilled prior to dowelling, nailing or screwing.'
        },
        {
          id: 3,
          icon: 'icon-work-03',
          title: 'Gluing',
          info: 'PVA wood glues are recommended for gluing prior to fixing. If MDF (MR) is to be used in areas of high humidity, a water resistant adhesive such as a two pack resorcinol or epoxy type for gluing the joints is recommended.'
        },
        {
          id: 4,
          icon: 'icon-work-04',
          title: 'Painting',
          info: 'Oil, water-based paints and varnishes may be used. It is recommend that all faces are sealed with a moisture resistant sealant.'
        },
        {
          id: 5,
          icon: 'icon-work-05',
          title: 'Safety',
          info: 'It is recommended that when working with MDF suitable dust masks are worn and the work environment is well ventilated.'
        }
      ]
    }
  }
}
